import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Portfolio = () => (
  <section id="work" data-testid="portfolio-section" className="relative py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeading
            overline="Our work"
            title="Recent concepts & projects."
            sub="A selection of project concepts showing the standard we build to. Real client launches will replace these as they go live."
          />
        </div>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {PORTFOLIO.map((p, i) => (
          <Reveal key={p.id} delay={0.07 * i} className={i === 0 ? "md:col-span-2 lg:col-span-1" : ""}>
            <article data-testid={`portfolio-card-${p.id}`}
              className="group bg-white border border-slate-200 rounded-3xl overflow-hidden h-full flex flex-col soft-shadow transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#0055FF]/30 hover:shadow-[0_16px_48px_rgba(2,6,23,0.08)]">
              <div className="relative overflow-hidden aspect-[4/3]">
                <img src={p.image} alt={`${p.title} — ${p.category} website preview`} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                <span className="absolute top-4 left-4 font-mono2 text-[10px] tracking-widest uppercase text-slate-700 bg-white/90 backdrop-blur-md border border-slate-200 rounded-full px-3 py-1.5">
                  {p.category}
                </span>
                {p.placeholder && (
                  <span className="absolute top-4 right-4 text-[10px] text-slate-600 bg-white/90 backdrop-blur-md border border-slate-200 rounded-full px-3 py-1.5">
                    Concept placeholder
                  </span>
                )}
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display text-xl font-semibold text-slate-900 tracking-tight">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{p.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {p.services.map((s) => (
                    <span key={s} className="text-[11px] text-slate-600 bg-slate-50 border border-slate-200 rounded-full px-2.5 py-1">{s}</span>
                  ))}
                </div>
                <a href="#contact" data-testid={`portfolio-view-${p.id}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#0055FF] hover:text-cyan-600 transition-colors duration-200">
                  View project <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
